import React, { FC } from 'react'
import { RegistrationMessage } from './RegistrationMessage'

export const LoginAfterRegistrationErrorMessage: FC = () => (
  <RegistrationMessage
    message={{
      type: 'error',
      name: 'login',
      details:
        'Account registration succeeded, but an error occurred while logging ' +
        'into your new account. Please use the following link to continue.',
      actions: ['reset_password'],
    }}
  />
)
